export const MIN_DATE = new Date(0, 0, 0);
export const MAX_DATE = new Date();
export const MIN_YEAR = Number(new Date(0, 0, 0).getFullYear());
export const MAX_YEAR = Number(new Date().getFullYear());

export const NNBSP = '\u202F';
export const AMOUNT_REGEXP = /^(?:\d+\.?\d*|\.\d+)$/;
export const SPACE_REGEXP = /\s/g;
export const CARD_NUMBER_PLACEHOLDER = '0000 0000 0000 0000';
export const PASSWORD_PLACEHOLDER = '*******';
export const SECOND = 1000;
export const QUARTER = 3;
export const MOBILE_DEVICE_MAX_WIDTH = 768;
export const ONBOARDING_BORDER_MAX_WIDTH = 1366;
export const DESKTOP_LG_MIN_WIDTH = 1440;
export const PLACES_CANT_RECEIVE_FROM =
  'https://wise.com/help/articles/3MObHiWysjT2DzDNHTupa4/what-countries-can-i-receive-international-swift-payments-from';
